import Vue from 'vue';  // Import Vue if you're using Vue 2.x

// Create a new Vue instance to act as the event bus
export const EventBus = new Vue();
